/**
 * @generated SignedSource<<dbd0a344fb5b8301e272a3e591c634c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RestoreData_deletedTaskLevelInfo_Query$variables = {
  companyId?: number | null;
  taskEventCount: string;
};
export type RestoreData_deletedTaskLevelInfo_Query$data = {
  readonly viewer: {
    readonly missionControlData: {
      readonly deletedTaskLevelInfo: {
        readonly parentCompanyTaskId: number | null;
        readonly grandParentCompanyTaskId: number | null;
      } | null;
    } | null;
  } | null;
};
export type RestoreData_deletedTaskLevelInfo_Query = {
  variables: RestoreData_deletedTaskLevelInfo_Query$variables;
  response: RestoreData_deletedTaskLevelInfo_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskEventCount"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "companyId",
    "variableName": "companyId"
  },
  {
    "kind": "Variable",
    "name": "taskEventCount",
    "variableName": "taskEventCount"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentCompanyTaskId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grandParentCompanyTaskId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestoreData_deletedTaskLevelInfo_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "MissionControlDeletedTaskLevelInfoType",
                "kind": "LinkedField",
                "name": "deletedTaskLevelInfo",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestoreData_deletedTaskLevelInfo_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "MissionControlDeletedTaskLevelInfoType",
                "kind": "LinkedField",
                "name": "deletedTaskLevelInfo",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f390fb42f03cef2b562185d94ad9942c",
    "id": null,
    "metadata": {},
    "name": "RestoreData_deletedTaskLevelInfo_Query",
    "operationKind": "query",
    "text": "query RestoreData_deletedTaskLevelInfo_Query(\n  $companyId: Int\n  $taskEventCount: ID!\n) {\n  viewer {\n    missionControlData {\n      deletedTaskLevelInfo(companyId: $companyId, taskEventCount: $taskEventCount) {\n        parentCompanyTaskId\n        grandParentCompanyTaskId\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b6dab3af7ce03ac77f389eb68b8d7a5";

export default node;
